import { useState, useDeferredValue, memo } from "react";
import { useTranslation } from "react-i18next";
import {
	Paper,
	ListItem,
	ListItemIcon,
	TextField,
	IconButton,
	Divider,
} from "@mui/material";
// cmps
import GroupCategories from "./group-categories";
import CreateGroup from "./create-group";
import Svg from "../svg";
// services
import { icons } from "@local/theme";
// types
import type { FilteredGroups, GroupName } from "../../types/firmware-groups";

type Props = Readonly<{
	selectedGroupName: GroupName | undefined;
	groups: FilteredGroups;
	onGroupClick: (groupName: GroupName | undefined) => void;
	loading: boolean;
	fetchGroups: () => void;
	showGenericErrorMsg: number | undefined;
	setShowGenericErrorMsg: (value: number | undefined) => void;
}>;

const GroupCategoriesFilter = ({ selectedGroupName, onGroupClick, groups, loading, showGenericErrorMsg, setShowGenericErrorMsg, fetchGroups }: Props) => {
	const { t } = useTranslation();

	const [searchFilter, setSearchFilter] = useState("");
	const deferredSearchFilter = useDeferredValue(searchFilter.toLowerCase());

	return (
		<>
			<Paper component="section" className="sub-section" sx={{ maxWidth: 300 }}>
				<ListItem sx={{ padding: "12px 0" }} disableGutters={true}>
					<CreateGroup groupCategory="root" groups={groups} fetchGroups={fetchGroups} />
					<ListItemIcon sx={{ justifyContent: "center" }}><icons.Search /></ListItemIcon>
					<TextField
						id="tf-groupcategory-filter"
						placeholder={t("firmwareGroups.placeholder")}
						value={searchFilter}
						onChange={(event) => (setSearchFilter(event.target.value))}
					/>
					<IconButton
						id="btn-clear-groupcategory-filter"
						aria-label={t("firmwareGroups.clearFilter")}
						sx={{ marginRight: "4px" }}
						onClick={() => (setSearchFilter(""))}
					>
						<Svg src="actions/clear.svg" />
					</IconButton>
				</ListItem>
				<Divider />
			</Paper>
			<section>
				<GroupCategories
					selectedGroupName={selectedGroupName}
					searchFilter={deferredSearchFilter}
					onGroupClick={onGroupClick}
					groups={groups}
					fetchGroups={fetchGroups}
					loading={loading}
					showGenericErrorMsg={showGenericErrorMsg}
					setShowGenericErrorMsg={setShowGenericErrorMsg}
				/>
			</section>
		</>
	);
};

export default memo(GroupCategoriesFilter);
